import { Autocomplete, DatePicker } from '@fullscreendigital/carrefour-dex-fe'
import { getCurrentDate, getPreviousWeek } from 'utils/helpers'
import { MultivalueCell } from 'components/core-ui/MultivalueCell'
import type { DailyReportReportTableItem, ReportUploadStatus } from '../interfaces'
import { MetiReportsCell } from '../common/MetiReportsModal'

const reportUploadStatusLabels: Record<NonNullable<ReportUploadStatus>, string> = {
  MANUAL_UPLOAD: 'Manual',
  AUTOMATIC_UPLOAD: 'Automat',
  MISSING_UPLOAD: 'Nefinalizat'
}

const getReportUploadStatusLabel = (status: ReportUploadStatus) =>
  status ? reportUploadStatusLabels[status] : '-'

export const getColumns = () => [
  {
    title: 'Nr. raport',
    field: 'reportNo',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Societate',
    field: 'legalEntityName',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Locatie',
    field: 'storeName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data',
    field: 'creationDate',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Categorii',
    field: 'categories',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '300px',
    render: (row: DailyReportReportTableItem) => <MultivalueCell value={row.categories} size={1} />
  },
  {
    title: 'Destinatari',
    field: 'companies',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true,
    render: (row: DailyReportReportTableItem) => <MultivalueCell value={row.companies} size={1} />
  },
  {
    title: 'Raport METI',
    field: 'metiReportIds',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '180px',
    render: (row: DailyReportReportTableItem) => <MetiReportsCell dailyReportId={row.id} />
  },
  {
    title: 'Greutatea cantarita (kg)',
    field: 'measuredWeight',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '150px'
  },
  {
    title: 'Greutatea din METI (kg)',
    field: 'totalCalculatedWeight',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '150px'
  },
  {
    title: 'Tip upload',
    field: 'reportUploadStatus',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '100px',
    render: (row: DailyReportReportTableItem) => getReportUploadStatusLabel(row.reportUploadStatus)
  }
]

const currentDate = getCurrentDate()
const previousWeek = getPreviousWeek()

export const getFilters = (
  legalEntitiesOptions: AutocompleteOption[],
  shopOptions: AutocompleteOption[],
  companyOptions: AutocompleteOption[],
  categoryOptions: AutocompleteOption[]
) => [
  {
    name: 'legalEntity',
    value: '',
    filter: (
      <Autocomplete variant="outlined" label="Societate" options={legalEntitiesOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Societate'
  },
  {
    name: 'storeIds',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Magazine" options={shopOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Magazine'
  },
  {
    name: 'startDate',
    value: previousWeek,
    filter: (
      <DatePicker
        label="Data inceput"
        variant="outlined"
        value={previousWeek}
        onChange={() => {}}
      />
    ),
    type: 'date',
    label: 'Data inceput'
  },
  {
    name: 'endDate',
    value: currentDate,
    filter: (
      <DatePicker label="Data sfarsit" variant="outlined" value={currentDate} onChange={() => {}} />
    ),
    type: 'date',
    label: 'Data sfarsit'
  },
  {
    name: 'categories',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Categorii" options={categoryOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Categorii'
  },
  {
    name: 'companyId',
    value: '',
    filter: <Autocomplete variant="outlined" label="Destinatar" options={companyOptions || []} />,
    type: 'autocomplete',
    label: 'Destinatar'
  },
  {
    name: 'reportUploadStatus',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Tip upload"
        options={[
          { value: 'MANUAL_UPLOAD', label: 'Manual' },
          { value: 'AUTOMATIC_UPLOAD', label: 'Automat' },
          { value: 'MISSING_UPLOAD', label: 'Nefinalizat' }
        ]}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Tip upload'
  }
]
